function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.856,256.001c0-127.397,96.194-232.311,219.907-246.114C274.648,8.87,265.387,8.329,256,8.329   C119.215,8.329,8.33,119.215,8.33,256.001S119.215,503.671,256,503.671c9.387,0,18.648-0.541,27.763-1.558   C160.049,488.311,63.856,383.398,63.856,256.001z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M256,512c-68.381,0-132.667-26.629-181.019-74.98C26.63,388.667,0.001,324.38,0.001,255.999  c0-68.82,26.934-133.404,75.839-181.857c3.267-3.237,8.541-3.213,11.778,0.054c3.237,3.268,3.213,8.541-0.056,11.779  C41.84,131.276,16.658,191.658,16.658,255.999c0,63.931,24.896,124.035,70.102,169.24c45.206,45.206,105.31,70.102,169.24,70.102  c57.105,0,112.403-20.45,155.707-57.583c3.491-2.995,8.75-2.591,11.744,0.901s2.591,8.75-0.901,11.745  C376.23,490.125,317.081,512,256,512z M440.906,429.079c-1.972,0-3.952-0.696-5.54-2.112c-3.434-3.062-3.735-8.327-0.674-11.759  c39.112-43.866,60.65-100.407,60.65-159.207c0-63.931-24.896-124.035-70.102-169.24C380.035,41.554,319.931,16.658,256,16.658  c-52.458,0-102.263,16.662-144.032,48.185c-3.671,2.772-8.894,2.041-11.665-1.63c-2.772-3.671-2.041-8.894,1.63-11.665  C146.617,17.825,199.892,0,256,0c68.381,0,132.667,26.629,181.019,74.98c48.352,48.352,74.98,112.639,74.98,181.019  c0,62.895-23.04,123.373-64.875,170.294C445.48,428.139,443.198,429.079,440.906,429.079z M288.983,363.127  c-1.449,0-2.897-0.378-4.192-1.133l-169.579-98.799c-2.561-1.493-4.137-4.233-4.137-7.196c0-2.963,1.575-5.705,4.137-7.196  l169.579-98.798c2.576-1.501,5.758-1.509,8.343-0.024c2.585,1.486,4.179,4.24,4.179,7.221v49.007h89.489  c4.6,0,8.329,3.729,8.329,8.329v82.923c0,4.6-3.729,8.329-8.329,8.329h-89.489v49.007c0,2.982-1.594,5.736-4.179,7.221  C291.848,362.759,290.415,363.127,288.983,363.127z M135.948,255.999l144.706,84.307v-42.845c0-4.6,3.729-8.329,8.329-8.329h89.489  v-66.265h-89.489c-4.6,0-8.329-3.729-8.329-8.329v-42.845L135.948,255.999z"
});

var SvgPrevious = function SvgPrevious(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M256.001,8.329C119.215,8.329,8.33,119.215,8.33,256.001S119.215,503.671,256,503.671  s247.671-110.886,247.671-247.671C503.672,119.215,392.786,8.329,256.001,8.329z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref2), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "black"
    },
    points: "386.801,297.462 288.983,297.462 288.983,354.798 119.403,256.001 288.983,157.202   288.983,214.538 386.801,214.538 "
  }), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrevious, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/previous.af91a27f.svg";
export { ForwardRef as ReactComponent };